import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { useSeoPageQueryApi } from 'graphql/generated';
import { getIsStaticUrlAllowed } from 'helpers/getIsStaticUrlAllowed';
import { useRouter } from 'next/router';
import { getSlugFromUrl } from 'utils/getSlugFromUrl';

/**
 * Returns SEO title and meta description for the current page from the globally prefetched SeoPageQuery (SSR).
 * Use with SeoMeta when the page does not have its own SEO data (e.g. friendly URL entity).
 * API call is skipped for non-static pages (e.g. product, category, article).
 */
export const useSeoPageSettings = () => {
    const router = useRouter();
    const { url: domainUrl } = useDomainConfig();
    let slug = getSlugFromUrl(router.asPath);
    const path = '/' + slug;
    let isStaticPage = getIsStaticUrlAllowed(path, domainUrl);

    // override for homepage path
    if (path === '/') {
        slug = 'homepage';
        isStaticPage = true;
    }

    const [{ data }] = useSeoPageQueryApi({
        variables: { pageSlug: slug },
        pause: !isStaticPage || typeof slug !== 'string',
    });

    return {
        title: data?.seoPage?.title ?? null,
        metaDescription: data?.seoPage?.metaDescription ?? null,
        canonicalUrl: data?.seoPage?.canonicalUrl ?? null,
        ogTitle: data?.seoPage?.ogTitle ?? null,
        ogDescription: data?.seoPage?.ogDescription ?? null,
    };
};
